// src/composables/useAuth.js - Helper central de autorización frontend
// No duplica matriz en frontend; lee usuario.permisos de backend (login / verify)
// ADMINISTRADOR tiene bypass total (isAdmin)

function normalizeRol(value) {
  return String(value || "").trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
}

function normalizePerm(value) {
  return String(value || "").trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
}

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user || null;
  } catch (_) {
    return null;
  }
}

export function getPermissions() {
  const user = getCurrentUser();
  if (!user) return [];
  const perms = user.permisos || user.permissions || [];
  if (!Array.isArray(perms)) return [];
  return perms;
}

export function isAdmin() {
  const user = getCurrentUser();
  if (!user) return false;
  const rolStr = typeof user.rol === "string" ? user.rol : (user.rol?.nombre || "");
  // No usar rol_id ===1 como autoridad; solo string normalizado
  return normalizeRol(rolStr) === "ADMINISTRADOR";
}

export function isSocio() {
  const user = getCurrentUser();
  if (!user) return false;
  const rolStr = typeof user.rol === "string" ? user.rol : (user.rol?.nombre || "");
  return normalizeRol(rolStr) === "SOCIO";
}

export function hasPermission(permission) {
  if (isAdmin()) return true;
  const perms = getPermissions().map(normalizePerm);
  return perms.includes(normalizePerm(permission));
}

export function hasAnyPermission(permissions) {
  if (isAdmin()) return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((p) => hasPermission(p));
}

// Para uso en setup() con reactividad mínima (no Pinia). Si necesitas reactividad, usar computed que llame a estas funciones.
export default {
  getCurrentUser,
  getPermissions,
  hasPermission,
  hasAnyPermission,
  isAdmin,
  isSocio,
  normalizeRol,
  normalizePerm,
};
